import script from "./AdminAcheteurSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminAcheteurSearch.vue?vue&type=script&setup=true&lang=ts"

import "./AdminAcheteurSearch.vue?vue&type=style&index=0&id=b8b89bba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8b89bba"]])

export default __exports__